<template>
  <div class="media">
    <div class="media-left" v-if="$slots.left">
      <slot name="left"></slot>
    </div>
    <div class="media-body" v-if="$slots.default">
      <slot></slot>
    </div>
    <div class="media-body" v-if="$slots.body">
      <slot name="body"></slot>
    </div>
    <div class="media-right" v-if="$slots.right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallMedia'
}
</script>

<style lang="scss">
@import "~@cdn_css/helper.scss";

.media {
  // overflow: hidden;
  zoom: 1;
}

.media-left {
  @extend %media;
}

.media-body {
  @extend .media;
  @extend %media;

  width: 10000px;
}

.media-right {
  @extend %media;
}
</style>
